import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en.json';
import zh from './zh.json';

Vue.use(VueI18n);

const messages = {
  en,
  zh
};

const i18n = new VueI18n({
  locale: 'en', // 设置默认语言
  messages, // 设置语言包
  silentTranslationWarn: true // 禁止警告未找到的翻译
});

export default i18n;
